function getAuthorization() {
  const token = localStorage.getItem("authToken");
  return token;
}

function getCompanyId() {
  const raw = localStorage.getItem("companyId");
  if (raw == null) return null;
  let id = String(raw).trim();
  if (!id || id === "null" || id === "undefined") return null;
  // Normalize legacy JSON-stringified values ("\"uuid\"")
  while (
    (id.startsWith('"') && id.endsWith('"')) ||
    (id.startsWith("'") && id.endsWith("'"))
  ) {
    try {
      const parsed = JSON.parse(id);
      if (typeof parsed === "string") {
        id = parsed;
        continue;
      }
    } catch {
      // ignore
    }
    id = id.slice(1, -1);
  }
  return id.replace(/^"+|"+$/g, "") || null;
}

function setAuthorization(token, companyId) {
  localStorage.setItem("authToken", token);
  // Always store a plain string — never JSON.stringify
  const cleanId =
    companyId == null ? "" : String(companyId).replace(/^"+|"+$/g, "");
  localStorage.setItem("companyId", cleanId);
  return true;
}

function removeAuthorization() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("companyId");
  return true;
}

export {
  getAuthorization,
  setAuthorization,
  removeAuthorization,
  getCompanyId,
};
